/**
 * Formats a string into a valid telephone number
 * (only numbers and the plus symbol with no spaces)
 */
export const formatTelephone = (telephoneNumber: string): string => {
  return telephoneNumber.replace(/[^(\d|+)]/g, "");
};
